// extracted by mini-css-extract-plugin
export default {"container":"oS-z","topReviewHeading":"pS-z","criticalReview":"qS-z","favorableReview":"rS-z","vsSeparator":"sS-z"};